<a class="skip-link" href="javascript:void(0)" (click)="onClick('main')" aria-label="Skip to Content">Skip to content</a>
<router-outlet (activate)="onActivate($event)"></router-outlet>
